import { axios } from "../../utils/axiosBase";
import { FETCH_PRODUCT_DETAIL, LOAD_PRODUCT_DETAIL } from "./types";

const fetchProductDetail =
  (
    currentLang,
    userId,
    product_urlseo,
    pronta_consegna_id = null,
    sottocodice = null,
    history
  ) =>
  async (dispatch, getState) => {
    const payload = {
      currentLang: currentLang,
      userId: userId,
      sottocodice: sottocodice,
    };

    // chiamo web service
    let response;
    if (pronta_consegna_id) {
      response = await axios.post(
        `api/productdetail/${product_urlseo}/${pronta_consegna_id}/`,
        payload,
        {
          withCredentials: true,
        }
      );
    } else {
      response = await axios.post(
        `api/productdetail/${product_urlseo}/`,
        payload,
        {
          withCredentials: true,
        }
      );
    }

    dispatch({
      type: FETCH_PRODUCT_DETAIL,
      payload: response.data,
    });
  };

const loadProductDetail =
  (productLoaded, history) => async (dispatch, getState) => {
    dispatch({
      type: LOAD_PRODUCT_DETAIL,
      payload: {
        productLoaded,
      },
    });
  };

export default {
  fetchProductDetail,
  loadProductDetail,
};
